export function LoadingState() {
  return (
    <main className="flex min-h-screen items-center justify-center bg-white px-6 text-center text-base font-medium text-neutral-700">
      Loading
    </main>
  );
}
